export function buildRoute(slug, route) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const msdn = urlParams.get('msdn') || urlParams.get('msisdn') || null;

  let newPath = '/requests';

  if (slug && slug !== process.env.REACT_APP_CONSUMER_SLUG) {
    newPath += `/${slug}/${route}`;
  } else {
    newPath += `/${route}`;
  }
  if (msdn) {
    newPath += `?msdn=${msdn}`;
  }
  return newPath;
}
